import { Panel } from "@/components/admin/ui";

const inputClass = "mt-1 w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm font-semibold dark:border-white/15 dark:bg-white/5 dark:text-white";
const labelClass = "text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500";

const Toggle = ({ checked, onChange, testId }) => (
  <button
    type="button"
    onClick={() => onChange(!checked)}
    data-testid={testId}
    className={`relative h-7 w-12 shrink-0 rounded-full p-0 transition-colors duration-200 ${checked ? "bg-[#0052FF]" : "bg-slate-300 dark:bg-white/15"}`}
  >
    <span className={`absolute left-0 top-1 h-5 w-5 rounded-full bg-white transition-transform duration-200 ${checked ? "translate-x-6" : "translate-x-1"}`} />
  </button>
);

// Org-level override of the sliding inactivity logout window. Null = inherit the
// platform-wide default set by a platform admin under Admin → Settings.
export const SessionSecuritySection = ({ form, onChange, platformDefault }) => {
  const usingDefault = form.inactivity_timeout_minutes == null;

  return (
    <Panel title="Session Security" subtitle="How long members can stay idle before being signed out." testId="org-settings-session-security">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-bold text-slate-900 dark:text-white">Use platform default</p>
          <p className="text-xs text-slate-500 dark:text-slate-400">Platform default is {platformDefault ?? 30} minutes.</p>
        </div>
        <Toggle
          checked={usingDefault}
          onChange={(v) => onChange({ inactivity_timeout_minutes: v ? null : (platformDefault ?? 30) })}
          testId="org-settings-inactivity-use-default-toggle"
        />
      </div>
      {!usingDefault && (
        <div className="mt-4">
          <label className={labelClass}>Inactivity timeout (minutes)</label>
          <input
            type="number"
            min={30}
            max={100}
            value={form.inactivity_timeout_minutes ?? 30}
            onChange={(e) => onChange({ inactivity_timeout_minutes: e.target.value === "" ? "" : Number(e.target.value) })}
            data-testid="org-settings-inactivity-minutes-input"
            className={inputClass}
          />
          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">Must be between 30 and 100 minutes.</p>
        </div>
      )}
    </Panel>
  );
};
